const ENVIRONMENT = {
  development: 'development',
  staging: 'staging',
  production: 'production'
} as const

const isDevelopmentEnv = () => import.meta.env.DEV

const isStagingEnv = () => import.meta.env.MODE === 'staging'

const isProductionEnv = () => import.meta.env.MODE === 'production'

const getEnvironment = () => isStagingEnv() ? ENVIRONMENT.staging : ENVIRONMENT.production

export default {
  isDevelopmentEnv,
  isStagingEnv,
  isProductionEnv,
  getEnvironment
}
